import {NotificationList} from "./NotificationList";
import {NotificationEdit} from "./NotificationEdit";
import {NotificationCreate} from "./NotificationCreate";

export default {
    list: NotificationList,
    create: NotificationCreate,
    edit: NotificationEdit
};
